<script lang="ts">
    import WarningInline from './WarningInline.svelte';
    import { _ } from 'svelte-i18n';

    export let center: boolean = true;
</script>

<div class="container" class:center>
    <WarningInline text={$_('this_account_is_expired')} />
</div>

<style>
    .container {
        display: flex;
    }
    .center {
        padding: 7%;
        margin: 7%;
    }
</style>
